"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeConvertToFixed = exports.formatUnitIdToPartialView = exports.formatPhoneNumber = exports.getMakeFromVin = exports.deriveSerialFromVin = exports.eventsPer1000MilesToEventsPer1000Kilometers = exports.footpoundsToNewtonmeters = exports.kilometersToMiles = exports.milesPerHourPerSecondToKilometersPerHourPerSecond = exports.milesPerHourToKilometersPerHour = exports.milesToKilometers = exports.milesToMeters = exports.milesPerGallonToKilometersPerLiter = exports.litersPerHourToGallonsPerHour = exports.gallonsPerHourToLitersPerHour = exports.gallonsToLiters = exports.barsToMegapascals = exports.poundPerSquareInchesToBars = exports.poundPerSquareInchesToMillibars = exports.poundPerSquareInchesToMegaPascals = exports.poundPerSquareInchesToKiloPascals = exports.fahrenheitToCelsius = exports.nmToFtLbs = exports.kmPerHourToMilesPerHour = exports.celsiusToFahrenheit = exports.hoursFromSeconds = exports.secondsToHours = exports.metersToKm = exports.metersToMiles = exports.feetToMiles = exports.feetToMeters = exports.metersToFeet = exports.FOOTPOUNDS_PER_NEWTONMETERS = exports.LITERS_PER_GALLON = exports.BAR_PER_PSI = exports.HOURS_PER_SECOND = exports.MILES_PER_METER = exports.FEET_PER_MILE = exports.FEET_PER_METER = exports.metricToImperial = void 0;
var units_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/units"));
var vehicleMake_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/vehicleMake"));
/**
 *
 * @param value Metric value to convert
 * @param unit Unit type to convert into
 * @returns Converted value rounded to the nearest integer
 *
 * This could be easily modified to take in metric values as well.
 * However since data is stored in metric, there is usually no need.
 */
var metricToImperial = function (value, unit) {
    switch (unit) {
        case units_1.default.FAHRENHEIT:
            return Math.round((value * 1.8) + 32);
        case units_1.default.MILES_PER_HOUR:
            return Math.round(value * 0.621371);
        default:
            return value;
    }
};
exports.metricToImperial = metricToImperial;
exports.FEET_PER_METER = 3.28084;
exports.FEET_PER_MILE = 5280;
exports.MILES_PER_METER = 0.000621371;
exports.HOURS_PER_SECOND = 0.000277778;
exports.BAR_PER_PSI = 0.0689476;
exports.LITERS_PER_GALLON = 3.78541;
exports.FOOTPOUNDS_PER_NEWTONMETERS = 0.73756;
/**
 * Converts meters to imperial feet
 * @param meters meters to convert to feet
 */
var metersToFeet = function (meters) { return meters * exports.FEET_PER_METER; };
exports.metersToFeet = metersToFeet;
/**
 * Converts feet to meters
 * @param feet feet to convert to meters
 */
var feetToMeters = function (feet) { return feet / exports.FEET_PER_METER; };
exports.feetToMeters = feetToMeters;
/**
 * Converts feet to miles
 * @param feet feet to convert to miles
 */
var feetToMiles = function (feet) { return feet / exports.FEET_PER_MILE; };
exports.feetToMiles = feetToMiles;
/**
 * Converts meters to imperial miles
 * @param meters meters to convert to miles
 */
var metersToMiles = function (meters) { return meters * exports.MILES_PER_METER; };
exports.metersToMiles = metersToMiles;
/**
 * Converts meters to kilometers
 * @param meters meters to convert to kilometers
 */
var metersToKm = function (meters) { return meters / 1000; };
exports.metersToKm = metersToKm;
/**
 * Converts seconds to hours
 * @param seconds
 */
var secondsToHours = function (seconds) { return seconds * exports.HOURS_PER_SECOND; };
exports.secondsToHours = secondsToHours;
var hoursFromSeconds = function (secondsText) {
    var seconds = parseInt(secondsText, 10);
    return !Number.isNaN(seconds) ? Math.round((0, exports.secondsToHours)(seconds)).toString() : secondsText;
};
exports.hoursFromSeconds = hoursFromSeconds;
/**
 * @param celsius Temperature in Celsisus
 * @return temperature in Fahrenheit
 */
var celsiusToFahrenheit = function (celsius) { return ((celsius * 9) / 5) + 32; };
exports.celsiusToFahrenheit = celsiusToFahrenheit;
/**
 * Convert kilometers per hour to miles per hour
 * @param km to convert
 */
var kmPerHourToMilesPerHour = function (km) { return (0, exports.metricToImperial)(km, units_1.default.MILES_PER_HOUR); };
exports.kmPerHourToMilesPerHour = kmPerHourToMilesPerHour;
/**
 * @param nm Torque in Newtonmeters
 * @return Torque in Footpounds
 */
var nmToFtLbs = function (nm) { return nm * exports.FOOTPOUNDS_PER_NEWTONMETERS; };
exports.nmToFtLbs = nmToFtLbs;
/**
 * Converts fahrenheit to celsius
 *
 * @param fahrenheit value to convert to celsius
 * @return value converted to celsius
 */
var fahrenheitToCelsius = function (fahrenheit) { return ((fahrenheit - 32) * 5) / 9; };
exports.fahrenheitToCelsius = fahrenheitToCelsius;
/**
 * Converts pound per square inches to kilopascals
 *
 * @param psi value in pound per square inches
 * @return value converted to kilopascals
 */
var poundPerSquareInchesToKiloPascals = function (psi) { return psi * exports.BAR_PER_PSI * 100; };
exports.poundPerSquareInchesToKiloPascals = poundPerSquareInchesToKiloPascals;
/**
 * Converts pound per square inches to megapascals
 *
 * @param psi value in pound per square inches
 * @return value converted to megapascals
 */
var poundPerSquareInchesToMegaPascals = function (psi) { return (psi * exports.BAR_PER_PSI) / 10; };
exports.poundPerSquareInchesToMegaPascals = poundPerSquareInchesToMegaPascals;
/**
 * Converts pound per square inches to millibars
 *
 * @param psi value in pound per square inches
 * @return value converted to millibars
 */
var poundPerSquareInchesToMillibars = function (psi) { return psi * exports.BAR_PER_PSI * 1000; };
exports.poundPerSquareInchesToMillibars = poundPerSquareInchesToMillibars;
/**
 * Converts pound per square inches to bars
 *
 * @param psi value in pound per square inches
 * @return value converted to bars
 */
var poundPerSquareInchesToBars = function (psi) { return psi * exports.BAR_PER_PSI; };
exports.poundPerSquareInchesToBars = poundPerSquareInchesToBars;
/**
 * Converts bars to megapascals
 *
 * @param bar value in bars
 * @return value converted to megapascals
 */
var barsToMegapascals = function (bar) { return bar / 10; };
exports.barsToMegapascals = barsToMegapascals;
/**
 * Converts gallons to liters
 *
 * @param gal value in gallons
 * @return value converted to liters
 */
var gallonsToLiters = function (gal) { return gal * exports.LITERS_PER_GALLON; };
exports.gallonsToLiters = gallonsToLiters;
/**
 * Converts gallons per hour to liters per hour
 *
 * @param gph value in gallons per hour
 * @return value converted to liters per hour
 */
var gallonsPerHourToLitersPerHour = function (gph) { return gph * exports.LITERS_PER_GALLON; };
exports.gallonsPerHourToLitersPerHour = gallonsPerHourToLitersPerHour;
/**
 * Converts liters per hour to gallons per hour
 *
 * @param lph value in liters per hour
 * @return value converted to gallons per hour
 */
var litersPerHourToGallonsPerHour = function (lph) { return lph / exports.LITERS_PER_GALLON; };
exports.litersPerHourToGallonsPerHour = litersPerHourToGallonsPerHour;
/**
 * Converts miles per gallon to kilometers per liter
 *
 * @param mpg value in miles per gallon
 * @return value converted to kilometers per liter
 */
var milesPerGallonToKilometersPerLiter = function (mpg) { return mpg * (1 / exports.MILES_PER_METER / 1000 / exports.LITERS_PER_GALLON); };
exports.milesPerGallonToKilometersPerLiter = milesPerGallonToKilometersPerLiter;
/**
 * Converts miles to meters
 * @param miles value in miles
 * @return value converted to meters
 */
var milesToMeters = function (miles) { return miles / exports.MILES_PER_METER; };
exports.milesToMeters = milesToMeters;
/**
 * Converts miles to kilometers
 *
 * @param miles value in miles
 * @return value converted to kilometers
 */
var milesToKilometers = function (miles) { return (0, exports.milesToMeters)(miles) / 1000; };
exports.milesToKilometers = milesToKilometers;
/**
 * Converts miles per hour to kilometers per hour
 *
 * @param mph value in miles per hour
 * @return value converted to kilometers per hour
 */
var milesPerHourToKilometersPerHour = function (mph) { return (0, exports.milesToKilometers)(mph); };
exports.milesPerHourToKilometersPerHour = milesPerHourToKilometersPerHour;
/**
 * Converts miles per hour per second to kilometers per hour per second
 *
 * @param mphs value in miles per hour per second
 * @return value converted to kilometers per hour per second
 */
var milesPerHourPerSecondToKilometersPerHourPerSecond = function (mphs) { return (0, exports.milesToKilometers)(mphs); };
exports.milesPerHourPerSecondToKilometersPerHourPerSecond = milesPerHourPerSecondToKilometersPerHourPerSecond;
/**
 * Converts kilometers to miles
 *
 * @param kilometers value in kilometers
 * @return value converted to miles
 */
var kilometersToMiles = function (kilometers) { return kilometers * (1000 * exports.MILES_PER_METER); };
exports.kilometersToMiles = kilometersToMiles;
/**
 * Converts footpounds to newton meters
 *
 * @param footpounds value in footpounds
 * @return value converted to newton meters
 */
var footpoundsToNewtonmeters = function (footpounds) { return footpounds / exports.FOOTPOUNDS_PER_NEWTONMETERS; };
exports.footpoundsToNewtonmeters = footpoundsToNewtonmeters;
var eventsPer1000MilesToEventsPer1000Kilometers = function (events) { return (events / (0, exports.milesToKilometers)(1000)) * 1000; };
exports.eventsPer1000MilesToEventsPer1000Kilometers = eventsPer1000MilesToEventsPer1000Kilometers;
/**
 * @param vin Suprise, it's a vin.
 * @returns The last 6 characters of the vin (the vehicle's serial #).
 */
var deriveSerialFromVin = function (vin) { return vin.slice(-6); };
exports.deriveSerialFromVin = deriveSerialFromVin;
/**
 * @param vin Suprise, it's a vin.
 * @returns Make of the vehicle - Freightliner (3 or 1) or Western Star (5). Default to Western Star.
 */
var getMakeFromVin = function (vin) {
    var firstChar = vin.slice(0, 1);
    return ['1', '3'].includes(firstChar)
        ? vehicleMake_1.default.FREIGHTLINER
        : vehicleMake_1.default.WESTERN_STAR;
};
exports.getMakeFromVin = getMakeFromVin;
/**
 * Converts user input to a phone number.
 * Returns a string of the format (xxx) xxx-xxxx
 * @param phone string of user input to be converted
 */
var formatPhoneNumber = function (phone) {
    // Only keep the first 10 digits, get rid of everything else.
    var digits = phone.replace(/\D/g, '').substring(0, 10);
    var len = digits.length;
    var formattedNumber;
    if (len === 0) {
        formattedNumber = '';
    }
    else if (len <= 3) {
        formattedNumber = "(".concat(digits);
    }
    else if (len <= 6) {
        formattedNumber = "(".concat(digits.substr(0, 3), ") ").concat(digits.substr(3, 3));
    }
    else {
        formattedNumber = "(".concat(digits.substr(0, 3), ") ").concat(digits.substr(3, 3), "-").concat(digits.substr(6, 4));
    }
    return formattedNumber;
};
exports.formatPhoneNumber = formatPhoneNumber;
var formatUnitIdToPartialView = function (unitId) { return "...".concat(unitId.slice(-5)); };
exports.formatUnitIdToPartialView = formatUnitIdToPartialView;
/**
 * Converts value to fixed number.
 * Returns formatted number string or defaultValue, if value is not a number or not Finite
 */
var safeConvertToFixed = function (value, digits, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 'N\\A'; }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value.toFixed(digits);
    }
    return defaultValue;
};
exports.safeConvertToFixed = safeConvertToFixed;
